import script from "./Carousel-wap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Carousel-wap.vue?vue&type=script&lang=ts&setup=true"

import "./Carousel-wap.vue?vue&type=style&index=0&id=55945d3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55945d3f"]])

export default __exports__